import { colors } from "healthex-common/colors";
import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
import { FlexRow } from "./common.styles";
export const SourcesContentContainer = styled.div `
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 48px;
`;
export const SourcesStatsRow = styled(FlexRow) `
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
    box-sizing: border-box;
    padding: 16px;
    border-bottom: 0.57px solid ${colors.separator_main};
`;
export const SourcesStatTile = styled.div `
    display: flex;
    flex: 1;
    min-width: 0;
    align-items: flex-start;
    box-sizing: border-box;
    padding: 16px;
    border-radius: 24px;
    background-color: ${colors.white_main};
    border: 0.57px solid ${colors.separator_main};
`;
export const SourcesStatColumn = styled.div `
    display: flex;
    flex: 1;
    min-width: 0;
    flex-direction: column;
    gap: 4px;
`;
export const SourcesStatValue = styled.p `
    margin: 0;
    font-size: 32px;
    line-height: 36px;
    color: ${colors.black_main};
`;
export const SourcesStatLabel = styled.p `
    margin: 0;
    font-size: 13px;
    font-weight: ${fontWeights.BOLD};
    letter-spacing: -0.08px;
    line-height: 20px;
    color: ${colors.black_main};
`;
export const SectionHeaderRow = styled(FlexRow) `
    align-items: center;
    gap: 8px;
    width: 100%;
    box-sizing: border-box;
    padding: 24px 16px 16px;
`;
export const SectionHeaderText = styled.p `
    margin: 0;
    flex-shrink: 0;
    font-size: 12px;
    font-weight: ${fontWeights.BOLD};
    letter-spacing: 0.24px;
    text-transform: uppercase;
    color: ${colors.history_secondary_text};
`;
export const SectionHeaderLine = styled.div `
    flex: 1;
    height: 0;
    border-top: 0.37px solid ${colors.separator_main};
`;
export const SourcesListContainer = styled.div `
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: stretch;
    width: 100%;
    box-sizing: border-box;
    padding: 0 16px;
`;
export const AddSourcesContainer = styled.div `
    width: 100%;
    box-sizing: border-box;
    padding: 16px;
`;
export const AddSourcesBar = styled.button `
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    box-sizing: border-box;
    padding: 24px 16px;
    border-radius: 8px;
    border: 1px dashed ${colors.navy_light};
    background-color: rgba(13, 39, 64, 0.08);
    cursor: pointer;
    color: ${colors.navy_light};

    @media (hover: hover) {
        &:hover {
            opacity: 0.9;
        }
    }
`;
export const AddSourcesCopy = styled.p `
    margin: 0;
    flex: 1;
    text-align: left;
    font-size: 12px;
    font-weight: ${fontWeights.BOLD};
    line-height: 18px;
    color: ${colors.navy_light};
`;
export const AddSourcesButtonLabel = styled.span `
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    box-sizing: border-box;
    padding: 0 16px;
    border-radius: 100px;
    background-color: ${colors.navy_light};
    color: ${colors.white_main};
    font-size: 12px;
    font-weight: ${fontWeights.BOLD};
    flex-shrink: 0;
`;
export const ComingSoonSection = styled.div `
    width: 100%;
    box-sizing: border-box;
    padding: 0 16px;
`;
export const ComingSoonCard = styled.div `
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: flex-start;
    width: 100%;
    box-sizing: border-box;
    padding: 16px;
    border-radius: 16px;
    border: 1px dashed ${colors.separator_main};
`;
export const ComingSoonTitle = styled.p `
    margin: 0;
    font-size: 16px;
    font-weight: ${fontWeights.BOLD};
    letter-spacing: -0.31px;
    line-height: 21px;
    color: ${colors.black_main};
    width: 100%;
`;
export const ComingSoonDescription = styled.p `
    margin: 0;
    font-size: 14px;
    font-weight: ${fontWeights.NORMAL};
    letter-spacing: -0.15px;
    line-height: 21.5px;
    color: ${colors.black_lighter};
    width: 100%;
`;
export const ComingSoonLink = styled.p `
    margin: 0;
    font-size: 14px;
    font-weight: ${fontWeights.BOLD};
    letter-spacing: -0.15px;
    line-height: 21.5px;
    color: ${colors.blue_main};
    width: 100%;
`;
